import { useState, useEffect, useRef } from "react";
import { fetchDistinctExamSubjects, fetchDistinctOfstedGrades } from "./filterOptions.api";

export function useExamSubjectOptions() {
  const [subjects, setSubjects] = useState([]);
  const fetched = useRef(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;

    fetchDistinctExamSubjects()
      .then(setSubjects)
      .catch(() => setSubjects([]));
  }, []);

  return subjects;
}

const OFSTED_ORDER = ["Outstanding", "Good", "Requires Improvement", "Inadequate"];

export function useOfstedGradeOptions() {
  const [grades, setGrades] = useState([]);
  const fetched = useRef(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;

    fetchDistinctOfstedGrades()
      .then((g) => {
        const sorted = OFSTED_ORDER.filter((o) => g.includes(o));
        const rest = g.filter((o) => !OFSTED_ORDER.includes(o));
        setGrades([...sorted, ...rest]);
      })
      .catch(() => setGrades([]));
  }, []);

  return grades;
}
